import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Text, TextInput } from "@mantine/core";

import { PaginatedList } from "@components/shared";

export default function EvaluationList({
  items = [],
  requestInfo = {
    url: `/retrieve-assessments/`,
    data: {
      activity_status: "scored",
    },
  },
  refresh,
}) {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    search_value: "",
  });

  const reqData = {
    ...filters,
    ...requestInfo.data,
    refresh,
  };

  return (
    <div>
      {requestInfo && (
        <React.Fragment>
          <TextInput
            placeholder={t("search")}
            size="lg"
            value={filters.search_value}
            onChange={(e) =>
              setFilters({ ...filters, search_value: e.target.value })
            }
          />
        </React.Fragment>
      )}
      <PaginatedList
        tableData={items}
        requestInfo={{
          url: requestInfo.url,
          data: reqData,
        }}
        responseMapping={(r) =>
          r.map((m) => ({
            ...m,
            link_url: `/evaluations/${m.id}`,
          }))
        }
        displayFormatter={(item) => {
          return (
            <Card key={item.original.id}>
              <Text
                c="dark"
                component={Link}
                to={`/evaluations/${item.original.id}`}
                fw={700}
              >
                {item.original.user
                  ? `${item.original.user.first_name || ""} ${
                      item.original.user.last_name || ""
                    }`.trim() || item.original.user.email
                  : item.original.id}{" "}
                - {item.original.assessment_instrument?.name || item.original.name}
              </Text>
              <Text>{item.original.activity_status_formatted}</Text>
              <Text>
                Submitted{" "}
                {item.original.submitted_at
                  ? new Date(item.original.submitted_at).toLocaleString()
                  : "—"}
              </Text>
            </Card>
          );
        }}
      />
    </div>
  );
}
